export default "__VITE_ASSET__Q$aTm4d$__"